<template>
  <div class="page-container">
    <div class="page-content">
      <!-- 페이지 헤더 -->
      <div class="page-header mb-6">
        <div class="flex justify-between items-start">
          <div>
            <h1 class="page-title">채권 관리</h1>
            <p class="page-subtitle">
              국고채, 통안채, 크레딧 채권을 통합 관리합니다
            </p>
          </div>
          <!-- 날짜 선택기 -->
          <div class="flex-shrink-0">
            <SettingDateSelector v-model="selectedDate" @dateSelected="selectDate" />
          </div>
        </div>
      </div>

      <!-- 채권 타입 탭 -->
      <div class="card-base mb-6">
        <nav class="flex space-x-1 p-1 bg-gray-100 rounded-lg">
          <button v-for="type in bondTypes" :key="type" @click="selectBondType(type)"
            class="flex-1 py-3 px-4 text-sm font-medium rounded-md transition-all duration-200" :class="[
              isCurrentBondType(type)
                ? 'bg-white text-primary-600 shadow-sm'
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50',
            ]">
            <div class="flex items-center justify-center space-x-2">
              <i :class="getBondTypeIcon(type)" class="text-sm"></i>
              <span>{{ getBondTypeTitle(type) }}</span>
            </div>
          </button>
        </nav>
      </div>

      <!-- 하위 메뉴 탭 -->
      <div class="card-base mb-6">
        <nav class="flex space-x-4 border-b border-gray-200">
          <button v-for="menu in currentMenus" :key="menu.key" @click="selectSubMenu(menu.key)"
            class="py-3 px-4 border-b-2 font-medium text-sm transition-colors" :class="[
              isCurrentSubMenu(menu.key)
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
            ]">
            <div class="flex items-center space-x-2">
              <i :class="menu.icon" class="text-sm"></i>
              <span>{{ menu.title }}</span>
            </div>
          </button>
        </nav>
      </div>

      <!-- 컨텐츠 영역 -->
      <div class="min-h-[600px]">
        <Transition name="fade" mode="out-in">
          <!-- 국고채 메뉴 -->
          <KtbBasicComponent v-if="isCurrentBondType('KTB') && isCurrentSubMenu('basic')"
            :key="`ktb-basic-${selectedDate}`" :selected-date="selectedDate" />

          <!-- 통안채 메뉴 -->
          <MsbBasicComponent v-else-if="isCurrentBondType('MSB') && isCurrentSubMenu('basic')"
            :key="`msb-basic-${selectedDate}`" :selected-date="selectedDate" />

          <!-- 크레딧 메뉴 -->
          <CreditBasicComponent v-else-if="isCurrentBondType('CREDIT') && isCurrentSubMenu('basic')"
            :key="`credit-basic-${selectedDate}`" :selected-date="selectedDate" />
          <CreditIssuanceComponent v-else-if="isCurrentBondType('CREDIT') && isCurrentSubMenu('issuance')"
            :key="`credit-issuance-${selectedDate}`" :selected-date="selectedDate" />
          <CreditIssuerComponent v-else-if="isCurrentBondType('CREDIT') && isCurrentSubMenu('issuer')"
            :key="`credit-issuer-${selectedDate}`" :selected-date="selectedDate" />
          <CreditGroupComponent v-else-if="isCurrentBondType('CREDIT') && isCurrentSubMenu('group')"
            :key="`credit-group-${selectedDate}`" :selected-date="selectedDate" />
        </Transition>
      </div>
    </div>
  </div>
</template>

<script>
import { useBondSetting } from '@/composables/useBondSetting';
import SettingDateSelector from '@/components/settings/SettingDateSelector.vue';
import KtbBasicComponent from '@/components/settings/KtbBasicComponent.vue';
import MsbBasicComponent from '@/components/settings/MsbBasicComponent.vue';
import CreditBasicComponent from '@/components/settings/credit/CreditBasicComponent.vue';
import CreditIssuanceComponent from '@/components/settings/credit/CreditIssuanceComponent.vue';
import CreditIssuerComponent from '@/components/settings/credit/CreditIssuerComponent.vue';
import CreditGroupComponent from '@/components/settings/credit/CreditGroupComponent.vue';

export default {
  name: 'BondSettingView',
  components: {
    SettingDateSelector,
    KtbBasicComponent,
    MsbBasicComponent,
    CreditBasicComponent,
    CreditIssuanceComponent,
    CreditIssuerComponent,
    CreditGroupComponent,
  },

  setup() {
    // 채권 설정 관리 컴포저블 사용
    const {
      currentBondType,
      currentSubMenu,
      bondTypes,
      currentMenus,
      selectedDate,
      getBondTypeTitle,
      getBondTypeIcon,
      selectBondType,
      selectSubMenu,
      isCurrentBondType,
      isCurrentSubMenu,
      selectDate,
    } = useBondSetting();

    return {
      currentBondType,
      currentSubMenu,
      bondTypes,
      currentMenus,
      selectedDate,
      getBondTypeTitle,
      getBondTypeIcon,
      selectBondType,
      selectSubMenu,
      isCurrentBondType,
      isCurrentSubMenu,
      selectDate,
    };
  },
};
</script>

<style scoped>
/* 페이드 트랜지션 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
